const BADGES = [
  { icon: '\uD83C\uDFDB', label: 'NHIS', value: 'Built-in Integration' },
  { icon: '\uD83C\uDFE5', label: 'Standards', value: 'GHS-Aligned' },
  { icon: '\uD83D\uDD12', label: 'Encryption', value: 'AES-256 at Rest' },
  { icon: '\uD83D\uDCDC', label: 'Privacy', value: 'Ghana DPA Aligned' },
  { icon: '\uD83D\uDCF1', label: 'Access', value: 'Works on Any Phone' },
];

export default function TrustSection() {
  return (
    <section className="trust-section" id="nhis">
      <div className="section-tag">Security & Compliance</div>
      <h2 className="section-title" style={{ fontSize: 'clamp(24px, 4vw, 38px)', marginBottom: 8 }}>
        Built for Ghana. Trusted everywhere.
      </h2>
      <p style={{ color: 'var(--heka-gray-600)', maxWidth: 500, margin: '0 auto' }}>
        Built to meet Ghana's Data Protection Act, GHS standards, and NHIS requirements —
        your health data stays encrypted and private.
      </p>

      <div className="trust-badges">
        {BADGES.map((b) => (
          <div className="trust-badge" key={b.value}>
            <div className="tb-icon">{b.icon}</div>
            <div className="tb-text">
              <div className="tb-label">{b.label}</div>
              <div className="tb-value">{b.value}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
